// src/pages/RomPackagePage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../styles/EventPackagePage.css';
import Footer from '../components/Footer';

import rom1 from '../assets/rom1.jpg';
import rom3 from '../assets/rom3.jpg';
import rom4 from '../assets/rom4.jpg';
import rom5 from '../assets/rom5.jpg';
import rom6 from '../assets/rom6.jpg';
import rom7 from '../assets/rom7.jpg';
import rom8 from '../assets/rom8.jpg';
import rom13 from '../assets/rom13.jpg';
import rom14 from '../assets/rom14.jpg';
import rom15 from '../assets/rom15.jpg';
import rom16 from '../assets/rom16.jpg';
import rom17 from '../assets/rom17.jpg';
import rom18 from '../assets/rom18.jpg';
import rom19 from '../assets/rom19.jpg';
import rom20 from '../assets/rom20.jpg';
import rom21 from '../assets/rom21.jpg';
import rom22 from '../assets/rom22.jpg';

const IMAGES = [
  rom1, rom3, rom4, rom5, rom6, rom7, rom8, rom13, rom14,
  rom15, rom16, rom17, rom18, rom19, rom20, rom21, rom22,
];

const WHATSAPP_HREF =
  'https://wa.me/6590079953?text=Hi%20Lebua%20Thai%2C%20I%27d%20like%20to%20enquire%20about%20the%20ROM%20Ceremony%20Package.';

const RomPackagePage = () => (
  <div className="event-package-page">
    <header className="event-package-hero">
      <span className="event-package-hero__eyebrow">Book for Events</span>
      <h1 className="event-package-hero__title">ROM Ceremony Package</h1>
      <p className="event-package-hero__sub">
        Say "I do" at Lebua Thai. Nestled within the heritage charm of CHIJMES,
        our Register of Marriage package pairs an intimate ceremony setting
        with authentic Thai hospitality — so you and your guests can celebrate
        the moment in a beautiful, unforgettable space.
      </p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary event-package-hero__cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </header>

    <div className="event-package-grid">
      {IMAGES.map((img, i) => (
        <div key={i} className="event-package-item">
          <img
            src={img}
            alt={`ROM Ceremony Package at Lebua Thai ${i + 1}`}
            loading="lazy"
          />
        </div>
      ))}
    </div>

    <section className="event-package-reserve">
      <h2>Planning Your ROM?</h2>
      <p>Let us help you bring your ceremony to life — reach out for availability and package details.</p>
      <a
        href={WHATSAPP_HREF}
        className="btn btn-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} /> Enquire on WhatsApp
      </a>
    </section>

    <Footer />
  </div>
);

export default RomPackagePage;
